import { axios } from '@Root/API'

export const updateFormEmail = (id, payload) => {
  return axios.put(`cognito-form-emails/${id}`, payload)
}
